import React, { useRef, useState } from "react";
import Tab from "../../components/Tab";
import { Search } from "react-feather";
import TaxSearch from "../../components/finance/TaxSearch";
import {
  addTaxSetup,
  deleteTax,
  searchTax,
  taxGetById,
  updateTax,
} from "../../api/finance/taxApi";
import SideDrawer from "../../components/input/SideDrawer";
import TaxRegistration from "../../components/finance/TaxRegistration";
import Grid from "../../components/Grid";
import LoadingSpinner from "../../components/LoadingSpinner";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import { formatFromJsonDate } from "../../dateConfig";
import { ResizableScrollingTextRenderer } from "../../components/renderer/StyleRenderer";
import { FORMS, MODULES } from "../../const";
import Button from "../../components/input/Button";
import useFirstAndLastAuthorizedTab from "../../hooks/useFirstAndLastAuthorizedTab";
import { toast } from "react-toastify";

function TaxManagement() {
  const { firstViableTab } = useFirstAndLastAuthorizedTab({
    module: MODULES.Finance,
    section: FORMS.TAX_MANAGER,
  });
  const [tab, setTab] = useState(1);
  const [activeAccordion, setActiveAccordion] = useState(1);
  const [searchClicked, setSearchClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [taxs, setTaxs] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [drawerTab, setDrawerTab] = useState(1);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentTaxData, setCurrentTaxData] = useState(null);
  const gridRef = useRef();

  const [taxCode, setTaxCode] = useState();
  const handleAccordionClick = (index) => {
    setActiveAccordion(index === activeAccordion ? null : index);
  };

  const handleSearch = async (data, searchParams) => {
    setSearchClicked(true);
    setIsLoading(true);
    try {
      const result = await searchTax(data);
      console.log("Search Results:", result); // Debug: Log search results
      setTaxs(
        result.map((taxDetails) => ({
          ...taxDetails,
          fromDate: formatFromJsonDate(taxDetails.tad_start),
          toDate: formatFromJsonDate(taxDetails.tad_end),
        }))
      );
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  const handleDrawerOpen = () => {
    setEditMode(false);
    setDrawerTab(1);
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
  };

  // const handleSubmit = async (taxRequest) => {
  //   setIsLoading(true);
  //   try {
  //     await addTaxSetup(taxRequest);
  //     setIsDrawerOpen(false);
  //   } catch (error) {
  //     console.error(error);
  //   }
  //   setIsLoading(false);
  // };

  const handleSubmit = async (taxId, taxRequest) => {
    setIsLoading(true);
    try {
      console.log("Payload being sent:", taxRequest);
      if (editMode) {
        await updateTax(taxId, taxRequest);
        toast.success("Tax updated successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        console.log("taxRequest", taxRequest);
        await addTaxSetup(taxRequest);
        toast.success("Tax added successfully!", {
          autoClose: 5000,
          containerId: "Main",
        });
      }
      setIsDrawerOpen(false);
    } catch (error) {
      console.error(error);
      toast.error("Tax did not add successfully!", {
        autoClose: 5000,
        containerId: "Main",
      });
    }
    setIsLoading(false);
  };

  const handleSelectionChanged = () => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);
  };

  const handleDeleteTax = async (taxId) => {
    setIsLoading(true);
    try {
      await deleteTax(taxId); // Call deleteTax function
      setTaxs((prevTaxs) => prevTaxs.filter((tax) => tax.tax_id !== taxId)); // Remove deleted tax from the list
      console.log(`Tax record with ID ${taxId} deleted successfully`);
    } catch (error) {
      console.error(`Failed to delete tax record with ID ${taxId}`, error);
    }
    setIsLoading(false);
  };

  const handleRowDoubleClicked = async (row) => {
    console.log(row);
    setIsLoading(true);
    try {
      const taxData = await taxGetById(row.data.tax_id);
      setCurrentTaxData({
        ...taxData,
        originalTaxName: taxData.taxTax, // Add this field
      });
      setEditMode(true);
      setIsDrawerOpen(true);
      setTaxCode(row.data.tax_id); // Set the taxCode for the update
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  return (
    <>
      <div
        className="ui attached tabular"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div className="ui tabular menu top attached">
          <Tab
            Icon={Search}
            onClick={() => {
              setTab(1);
            }}
            active={tab === 1}
            label="Search"
          />
        </div>
        <Button
          template="drawerOpen"
          disabled={firstViableTab === -1}
          onClick={handleDrawerOpen}
          authenticated={true}
          form={FORMS.TAX_MANAGER.HEADER.form}
          module={MODULES.Finance}
          editMode={false}
        />
      </div>
      <div
        className="ui bottom attached active tab segment"
        style={{ display: tab === 1 ? "block" : "none" }}
      >
        <div
          className="ui styled accordion"
          style={{ width: "100%", marginBottom: "10px" }}
        >
          <div
            className={`title ${activeAccordion === 1 ? "active" : ""}`}
            onClick={() => handleAccordionClick(1)}
          >
            <div>
              Search
              <Search size={14} style={{ marginLeft: "10px" }} />
              <i className="dropdown icon"></i>
            </div>
          </div>
          <div className={`content ${activeAccordion === 1 ? "active" : ""}`}>
            <TaxSearch
              searchResHandler={handleSearch}
              resetHandler={() => {}}
            />
          </div>
        </div>
        {searchClicked && (
          <>
            {isLoading ? (
              <LoadingSpinner />
            ) : (
              <Grid
                ref={gridRef}
                wrapText={false}
                heading="Search Results"
                multiRowSelection={true}
                onSelectionChanged={handleSelectionChanged}
                isLoading={isLoading}
                searchable={true}
                onRowDoubleClicked={handleRowDoubleClicked}
                config={[
                  // { headerName: "Tax ID", field: "tax_id" },
                  { headerName: "Tax Code", field: "tax_code" },
                  {
                    headerName: "Tax Name",
                    field: "tax_tax",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  // {
                  //   headerName: "Description",
                  //   field: "tax_description",
                  //   cellRenderer: ResizableScrollingTextRenderer,
                  // },
                  { headerName: "Calculation Type", field: "calc_name" },
                  { headerName: "Status", field: "tax_status_name" },
                  { headerName: "Active", field: "tax_active_name" },
                  {
                    headerName: "Edit",
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        console.log("Params Data:", params.data);
                        handleRowDoubleClicked(params);
                      },

                      label: "Edit",
                    }),
                  },
                  {
                    headerName: "Delete",
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        handleDeleteTax(params.data.tax_id); // Delete tax on click
                      },
                      label: "Delete",
                      className: "ui red button",
                    }),
                  },
                ]}
                content={taxs}
              />
            )}
          </>
        )}
      </div>

      <SideDrawer
        open={isDrawerOpen}
        handleDrawerClose={handleDrawerClose}
        head={
          <div className="drawer-header">
            <div style={{ padding: "10px 0 10px 0" }}>
              <h3>Tax Registration</h3>
            </div>
          </div>
        }
        body={
          <TaxRegistration
            onSubmit={handleSubmit}
            editMode={editMode}
            initialData={currentTaxData}
          />
        }
        style={{ width: "80vw", boxShadow: "none" }}
      />
    </>
  );
}

export default TaxManagement;
